module.exports = __webpack_public_path__ + "img/map_toilet_1@2x.dda41e4b.png";